import React from 'react';
import './CrossCountryStrip.scss';

function CrossCountryStrip(props) {
    const { country, domain } = props.countryData;
    const { dataLocale: { YOU_ARE_ON_INDIAN_WEB, WEBSITE, TO_PURCHASE_FROM, CLICK_HERE } } = this.props;
    return (<div className="cross-country-strip padding-12 text-center">
        <span>{YOU_ARE_ON_INDIAN_WEB} {TO_PURCHASE_FROM} {country} {WEBSITE}</span>
        <a href={`https://${domain}?ref=https://www.lenskart.com`} className="button-cta fw500 margin-l20 padding-t4 padding-b4 padding-l12 padding-r12">{CLICK_HERE}</a>
    </div>);
}

export default CrossCountryStrip;
